import React from "react";

export class ShippingField extends React.Component<any, any> {

    render() {
        if (!this.props.shipping_location_id) {
            return this.createSimpleField();
        }
        return this.createPPField();
    }

    private createSimpleField() {

        if (!this.props.shipping_agent && !this.props.shipping_method) {
            return '';
        }
        if (!this.props.shipping_agent || this.props.shipping_agent === this.props.shipping_method) {
            return (<>{this.props.shipping_method}</>);
        }
        if (!this.props.shipping_method) {
            return (<>{this.props.shipping_agent}</>);
        }
        return (<>
            A: {this.props.shipping_agent}<br/>
            M: {this.props.shipping_method}
        </>);
    }

    private createPPField() {

        if (!this.props.shipping_method && !this.props.shipping_agent) {
            return (<>Location: {this.props.shipping_location_id}</>);
        }
        if (!this.props.shipping_agent || this.props.shipping_agent === this.props.shipping_method) {
            return (<>{this.props.shipping_method}: {this.props.shipping_location_id}</>);
        }
        if (!this.props.shipping_method) {
            return (<>A: {this.props.shipping_agent}: {this.props.shipping_location_id}</>);
        }
        return (<>
            A: {this.props.shipping_agent}<br/>
            M: {this.props.shipping_method}: {this.props.shipping_location_id}
        </>);
    }
}